export default __webpack_public_path__ + "static/media/logo.c5695d38.svg";